export enum INSTANCE_COPY {
    /**
     * @value Site copy
     * @description Site copy tool nav item, used to access the new tool that allows users to copy a site on their platform.
     */
    COPY = 'ADMIN.NAV.INSTANCES.COPY',
}
